import React, { useContext } from 'react';
import { Header as SharedHeader } from '@spotify-internal/masthead-react';
import styled from 'styled-components';

import { MarketContext } from 'providers/market';
import { useVerticalConfig } from 'providers/vertical';
import { useMastheadData } from 'providers/MastheadProvider';
import { TurnkeyNavBar } from 'components/Masthead/Header';

import S4AHeader from './S4AHeader';

interface ContainerProps {
  transparent: boolean;
}

const PLAIN_DATA = {
  navigation: {
    brand: {
      href: '#',
      alt: 'Spotify',
    },
  },
};

const Container = styled.div<ContainerProps>`
  a[href='#'] {
    cursor: default;
  }

  header {
    ${props => props.transparent && 'background: transparent !important;'}
  }
`;

const Gradient = styled.div`
  position: absolute;
  width: 100%;
  height: 200px;
  z-index: -1;
  background: linear-gradient(98.85deg, rgba(18, 18, 18, 0.3) 0%, var(--background-base) 100%),
    linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, var(--background-base) 100%), var(--text-bright-accent);
`;

export const Header = () => {
  const { header } = useMastheadData();
  const { preferredDir } = useContext(MarketContext);
  const { features } = useVerticalConfig();
  const { showHeaderGradient, configureMasthead } = features;

  const headerProps = header ?? PLAIN_DATA;

  return (
    <Container transparent={showHeaderGradient}>
      {showHeaderGradient && <Gradient aria-hidden="true" />}
      {!configureMasthead && (
        <div dir={preferredDir}>
          <SharedHeader {...headerProps} fixed={false} transparent={showHeaderGradient} />
        </div>
      )}
      {configureMasthead?.header === 's4a' && <S4AHeader />}
      {configureMasthead?.header === 'turnkey' && <TurnkeyNavBar />}
    </Container>
  );
};
